function MergeCustomersModalCtrl($scope, $uibModalInstance, customers, modalHeader, venueId) {
  $scope.customers = customers;
  $scope.modalHeader = modalHeader;
  $scope.venueId = venueId;

  $scope.onMerged = function (result) {
    $uibModalInstance.close(result);
  };

  $scope.close = function () {
    $uibModalInstance.close(false);
  };
}

MergeCustomersModalCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'customers',
  'modalHeader',
  'venueId'
];

export default MergeCustomersModalCtrl;



// WEBPACK FOOTER //
// ./src/modals/mergeCustomers/controller.js